module.exports = __webpack_public_path__ + "media/brands/ssangyong-ba316d38.png";